import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class PMOSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForPMO = this.yAccessorForPMO.bind(this);
    this.yAccessorForSignal = this.yAccessorForSignal.bind(this);
  }
  yAccessorForPMO(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).pmo;
  }
  yAccessorForSignal(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).pmoSignal;
  }
  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;

    const { strokePMO, strokeSignal, strokeZeroLine } = this.props;

    const { clip } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForPMO}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokePMO}
          clip={clip}
        />
        <LineSeries
          yAccessor={this.yAccessorForSignal}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeSignal}
          clip={clip}
        />
        <StraightLine
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeZeroLine}
          yValue={0}
        />
      </g>
    );
  }
}

PMOSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  clip: PropTypes.bool.isRequired,
  strokePMO: PropTypes.object.isRequired,
  strokeSignal: PropTypes.object.isRequired,
  strokeZeroLine: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

PMOSeries.defaultProps = {
  className: "react-stockcharts-pmo-series",
  clip: true,
};

export default PMOSeries;
